import { useEffect, useState } from "react";

/**
 * Sichtbarkeit des Browser-Tabs (Page Visibility API). Der Chat markiert Nachrichten erst als gelesen, wenn der Tab sichtbar
 * ist; kommt der Tab aus dem Hintergrund zurück, holt er das nach (Gesamtprüfung 07.10.2026: vorher blieb eine im Hintergrund
 * eingetroffene Nachricht ungelesen, bis die nächste kam).
 */

type VisibilityDoc = Pick<Document, "visibilityState" | "addEventListener" | "removeEventListener">;

const doc = (): VisibilityDoc | null => (typeof document === "undefined" ? null : document);

/** Tab sichtbar? Ohne Dokument (Tests, Server) gilt: sichtbar. */
export function isDocumentVisible(d: Pick<Document, "visibilityState"> | null = doc()): boolean {
  return !d || d.visibilityState !== "hidden";
}

/** Bei jedem Wechsel (sichtbar ↔ Hintergrund) melden; Rückgabe meldet ab. */
export function onVisibilityChange(d: VisibilityDoc | null, cb: (visible: boolean) => void): () => void {
  if (!d) return () => undefined;
  const handler = () => cb(isDocumentVisible(d));
  d.addEventListener("visibilitychange", handler);
  return () => d.removeEventListener("visibilitychange", handler);
}

/** React: aktueller Stand, neu gerendert bei jedem Wechsel */
export function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(() => isDocumentVisible());
  useEffect(() => onVisibilityChange(doc(), setVisible), []);
  return visible;
}
